import React, { useCallback, useEffect, useState } from 'react'
import { ClassroomManager, isTutor } from '@helpers'

import Cursor from '../../../Cursor'
import { useAuth } from '../../../../hooks'

const CursorManager = () => {
  const { profile } = useAuth()
  const showStudentCursors = isTutor(profile.type)
  const [participants, setParticipants] = useState([])

  const observe = useCallback((clientId, data) => {
    setParticipants((prevParticipants) => {
      if (!data) {
        return prevParticipants.filter((p) => p.clientId !== clientId)
      }

      const nextParticipants = prevParticipants.filter(
        (p) => p.id !== data.id && p.clientId !== clientId
      )

      nextParticipants.push({
        ...data,
        clientId
      })

      return nextParticipants
    })
  }, [])

  useEffect(() => {
    ClassroomManager.observe('bindings:sketch:awareness', observe)
    return () => {
      ClassroomManager.unobserve('bindings:sketch:awareness', observe)
    }
  }, [observe])

  return (
    <>
      {participants.map((participant) => {
        if (showStudentCursors || participant.type === 'tutor')
          return (
            <Cursor
              key={participant.id}
              image={participant.image}
              name={participant.name}
              position={{
                top: participant.top,
                left: participant.left
              }}
            />
          )

        return null
      })}
    </>
  )
}

export default CursorManager
